import * as constant from "./constant";

const INITIAL_STATE = {
  loading: false,
  fileResponse: {
    httpStatus: 0,
    content: "",
  },
  textResponse: {
    httpStatus: 0,
    data: {
      httpStatus: 0,
      content: "",
      humanExpression: "",
    },
  },
  question: "",
  deleteChatResponse: {
    httpStatus: 0,
    data: "",
  },
};

const sendingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constant.LOADING:
      return Object.assign({}, state, {
        loading: action.payload,
      });
    case constant.FILE_RESPONSE:
      return Object.assign({}, state, {
        fileResponse: action.payload,
      });
    case constant.TEXT_RESPONSE:
      return Object.assign({}, state, {
        textResponse: action.payload,
      });
    case constant.QUESTION:
      return Object.assign({}, state, {
        question: action.payload,
      });
    case constant.DELETE_CHAT_RESPONSE:
      return Object.assign({}, state, {
        deleteChatResponse: action.payload,
      });
    default:
      return state;
  }
};

export default sendingReducer;
